import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import PrimerPaymentMethodType from './../../_common/paymentMethodTypeReactNative.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PrimerPaymentMethodType mdxType="PrimerPaymentMethodType" />
    <Item title='paymentMethodName' subtitle='string' label='Required' mdxType="Item">
	A user friendly English localized string identifier for the payment method.
    </Item>
    <Item title='nativeViewName' subtitle='string' label='Required' mdxType="Item">
	The name of the native view. Pass this to NativeResourceView when rendering.
    </Item>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`<NativeResourceView
    onPress={() => {
        // Handle tap
    }}
    nativeViewName={nativeViewResource.nativeViewName}
    style={{
        marginHorizontal: 20,
        marginVertical: 8,
        justifyContent: 'center',
        alignItems: 'center'
    }}
/>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      